import {
  loadAllSensors,
  loadSensorsRanch,
  loadSensorDetail,
  loadSensorDetailById,
  updateSensorLocation,
  createSensor,
  installSensor,
  uninstallSensor,
  removeSensor,
  replaceSensor,
  copySensorMetadataToCav,
  copySensorMetadataFromCav,
  cleanSensorsFetchState,
} from './reducers/sensors';

import {
  loadSensorStatsList,
  loadSensorStatsSingle,
  loadCavalierStatsList,
  loadCavalierStatsSingle,
  loadGatewayStatsList,
  loadGatewayStatsSingle,
  loadBlockStatsList,
  loadBlockStatsSingle,
} from './reducers/stats';

import { loadSensorImagesList } from './reducers/images';
import { loadSensorNotesList } from './reducers/notes';
import { loadSensorStatus, addItems } from './reducers/status';
import { loadSensorCapabilities } from './reducers/capabilities';
import { setSensorsStateForGeoJSON } from './reducers/sensors-geojson';

const loadSensorErrors = loadCavalierStatsSingle;

export {
  loadAllSensors,
  loadSensorsRanch,
  loadSensorDetail,
  loadSensorDetailById,
  // actions
  updateSensorLocation,
  createSensor,
  installSensor,
  uninstallSensor,
  removeSensor,
  replaceSensor,
  copySensorMetadataToCav,
  copySensorMetadataFromCav,
  cleanSensorsFetchState,

  loadSensorCapabilities,
  loadSensorStatus,
  addItems,
  // stats
  loadSensorStatsList,
  loadSensorStatsSingle,
  loadCavalierStatsList,
  loadCavalierStatsSingle,
  loadGatewayStatsList,
  loadGatewayStatsSingle,
  loadSensorErrors,
  // notes
  loadSensorNotesList,
  loadSensorImagesList,
  // sensorsgeojson
  setSensorsStateForGeoJSON,
  loadBlockStatsList,
  loadBlockStatsSingle,
};
